<template>
    <ies-form-field :field="field">
        <v-row>
            <v-col cols="12">
                <v-card outlined class="trip-category mb-2 pa-2" v-for="(item, index) in categories" :key="index">
                    <v-row dense align="center">
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                                label="Category"
                                hide-details
                                outlined
                                dense
                                clearable
                                :items="selectableCategories"
                                item-text="name"
                                item-value="category_key"
                                v-model="categories[index].category_key"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="10" class="text-right">
                            <v-btn icon small title="Move up" v-on:click="moveUp(index)" :disabled="index === 0"><v-icon>arrow_upward</v-icon></v-btn>
                            <v-btn icon small title="Move down" v-on:click="moveDown(index)" :disabled="index === categories.length - 1"><v-icon>arrow_downward</v-icon></v-btn>
                            <v-btn icon small title="Delete" class="ies-coral--text" v-on:click="deleteItem(index)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" offset-sm="9" class="text-right">
                <v-btn class="ies-green" title="Add Category" v-on:click="addItem()"><v-icon>add</v-icon></v-btn>
            </v-col>
            <input type="hidden" :name="this.field.fieldName" :value="field.value">
        </v-row>
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-input-trip-categories',
        props: ['field', 'recordData', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                tripKey: 0,
                categories: [],
                selectableCategories: [],
            }
        },

        created: function() {
            this.tripKey = this.getTripKeyFromUrl();
            if (this.tripKey > 0) {
                this.getCategories();
            }
            this.getSelectableCategories();
            this.syncFieldValue();
        },

        methods: {
            getTripKeyFromUrl: function() {
                if (!this.page || !this.page.edit_url) {
                    return 0;
                }
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index) {
                    if (bit == '{Trip.trip_key}') {
                        foundIndex = index;
                    }
                });
                if (foundIndex === null) {
                    return 0;
                }
                var urlBits = location.pathname.split('/').splice(1);
                return parseInt(urlBits[foundIndex]) || 0;
            },

            getSelectableCategories: function() {
                axios.get('/api/selectable-categories').then((response) => {
                    this.selectableCategories = response.data.categories;
                });
            },

            getCategories: function() {
                axios.get('/api/trip-categories/' + this.tripKey).then((response) => {
                    if (response.data.categories && response.data.categories.length) {
                        this.categories = response.data.categories.map(function(item) {
                            return {
                                category_key: item.category_key,
                                sort_order:   item.sort_order,
                            };
                        });
                        this.syncFieldValue();
                    }
                });
            },

            addItem: function() {
                this.categories.push({
                    category_key: null,
                    sort_order:   this.categories.length,
                });
            },

            deleteItem: function(index) {
                this.categories.splice(index, 1);
            },

            moveUp: function(index) {
                if (index === 0) {
                    return;
                }
                var moved = this.categories.splice(index, 1)[0];
                this.categories.splice(index - 1, 0, moved);
            },

            moveDown: function(index) {
                if (index === this.categories.length - 1) {
                    return;
                }
                var moved = this.categories.splice(index, 1)[0];
                this.categories.splice(index + 1, 0, moved);
            },

            syncFieldValue: function() {
                this.field.value = {
                    trip_key:   this.tripKey,
                    categories: this.categories,
                };
            },
        },

        watch: {
            categories: {
                handler: function() {
                    this.syncFieldValue();
                },
                deep: true,
            },
        },
    }
</script>
